import { lazy } from "react";
const Tweet = lazy(() => import('@/pages/tweet/Index'));
const listRoute = [
    {
        path: "/tweet",
        name: '推文',
        component: Tweet,
        multipleTab:"/tweet"
    }
]
export default listRoute